import React, { ReactNode } from "react";

interface CardProps {
    children: ReactNode;
    style?: React.CSSProperties;
}

const Card: React.FC<CardProps> = ({ children, style }) => {
    return (
        <div
            className="card"
            style={{
                ...style,
                border: "6px solid rgb(254, 112, 0)",
                borderRadius: "0px",
                padding: "5px",
            }}
        >
            {children}
        </div>
    );
};

export default Card;
